module.exports = __webpack_public_path__ + "img/top-vague-mobile.3286c943.jpg";